import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Logo from "../logo";
import './dialog.css';
import classNames from "classnames";

export const DIALOG_TYPE_THUMBS = 'thumbs';
export const DIALOG_TYPE_HANDS = 'hands';


class Dialog extends Component {

    render() {
        return (
            <div className={classNames({
                'Dialog': true,
                'Dialog--thumbs': (this.props.type ===  DIALOG_TYPE_THUMBS ? true : false),
            })}>
                <div className="Dialog__logo">
                    <Logo/>
                </div>
                <h2 className="Dialog__title">{this.props.title}</h2>
                <div className="Dialog__body">
                    {this.props.body}
                </div>
            </div>
        );
    }

}

Dialog.defaultProps = {
    type: DIALOG_TYPE_HANDS,
};

Dialog.propTypes = {
    title: PropTypes.string.isRequired,
    type: PropTypes.string,
    body: PropTypes.object,
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/dialog/index.js